import React from 'react';
import PropTypes from 'prop-types';
import css from './SectionHowItWorks.css';

const SectionHowItWorksIconLesson = props => {
  const { className } = props;

  return (
    <svg
      className={css.icons}
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="64"
      fill="none"
      viewBox="0 0 65 64"
    >
      <path
        stroke="#E77B20"
        strokeWidth="2"
        d="M41.053 11.293L40.76 11h-2.414a1 1 0 01-1-1V4a1 1 0 011-1h16a1 1 0 011 1v6a1 1 0 01-1 1h-10V13.586a.414.414 0 01-.707.293l-2.586-2.586z"
      ></path>
      <path
        fill="#614983"
        d="M63.346 44v-8c0-3.839-2.42-7.114-5.811-8.406A6.983 6.983 0 0060.345 22c0-3.859-3.14-7-7-7-3.858 0-7 3.141-7 7a6.992 6.992 0 002.982 5.722 17.854 17.854 0 00-3.006 1.173A10.536 10.536 0 0141.638 30h-.292v-7h-2v-4h-7c-1.654 0-3 1.346-3 3v11h-9v-9.118c6.332-1.012 11-6.418 11-12.927V4.5c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5V10c0 3.309-2.691 6-6 6h-.111a6.973 6.973 0 002.11-5c0-3.859-3.14-7-7-7-3.858 0-7 3.141-7 7a6.987 6.987 0 002.697 5.509C4.586 17.915 1.346 22.086 1.346 27v5.982c0 1.34.522 2.598 1.473 3.543.944.941 2.204 1.474 3.527 1.456V53c0 2.206 1.794 4 4 4a3.974 3.974 0 003-1.382 3.974 3.974 0 003 1.382c.732 0 1.409-.212 2-.556V63h6V41h22v2h-1.117a4.993 4.993 0 00-4.743 3.419L36.53 58.286A3.585 3.585 0 0039.927 63h.559c1.545 0 2.91-.984 3.396-2.448l2.464-7.39V63h6v-8h9c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2h-.111a6.973 6.973 0 002.11-5zm-15-22c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zm-9 8h-2.5c-1.93 0-3.5 1.57-3.5 3.5 0 .539.133 1.044.35 1.5h-1.35a1 1 0 01-1-1v-9.184c.314.112.648.184 1 .184h7v5zm-7-9h5v2h-5a1 1 0 010-2zm-6-11V4.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5v6.455a11.041 11.041 0 01-10.091 11.049l-.91.083v7.729a2.996 2.996 0 01-2-2.816v-9h2c4.412 0 8-3.589 8-8zm-18 1c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zM4.23 35.108a2.974 2.974 0 01-.884-2.126V27c0-4.275 2.998-7.855 7-8.768V27a2.996 2.996 0 01-2 2.816V24h-2v11.982c-.8 0-1.55-.31-2.116-.874zM16.346 55c-1.103 0-2-.897-2-2V34h-2v19c0 1.103-.897 2-2 2s-2-.897-2-2V31.899a5.009 5.009 0 004-4.899v-9h2v9a5.01 5.01 0 004 4.899V53c0 1.103-.897 2-2 2zm6 6h-2V41h2v20zm2-22h-4v-4h9.184a2.996 2.996 0 002.816 2h12.292c1.925 0 3.854-.455 5.577-1.316l.13-.066V39h-26zM45.17 50.367l-3.186 9.553A1.577 1.577 0 0140.486 61h-.56a1.582 1.582 0 01-1.5-2.081l3.956-11.867A2.998 2.998 0 0145.229 45h1.117v4.149a1.986 1.986 0 00-1.176 1.218zM50.346 61h-2V41h2v20zm11-10v2h-9v-2h9zm-9-2V34.618l1.447-.724-.895-1.789-3.578 1.789A10.516 10.516 0 0144.638 35h-7.792c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5h4.792c1.925 0 3.854-.455 5.577-1.316A16.02 16.02 0 0154.345 29c3.86 0 7 3.141 7 7v8c0 2.757-2.242 5-5 5h-4z"
      ></path>
      <path
        fill="#E77B20"
        d="M45.346 6h2v2h-2V6zM49.346 6h2v2h-2V6zM41.346 6h2v2h-2V6z"
      ></path>
    </svg>
  );
};

const { string } = PropTypes;

SectionHowItWorksIconLesson.defaultProps = {
  className: null,
};

SectionHowItWorksIconLesson.propTypes = {
  className: string,
};

export default SectionHowItWorksIconLesson;
